module.exports = __webpack_public_path__ + "img/diy-QrXmGrLi.4e8e7171.svg";